module.exports = __webpack_public_path__ + "img/lg_ring_y_e_1_0@2x.25027587.png";